// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Typography,
//   CircularProgress,
//   Box,
//   Paper,
//   TableContainer,
//   Button,
//   Tooltip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Snackbar,
//   Alert,
// } from "@mui/material";

// import { getAllRides, refundRide } from "../../services/api";
// import RideManageDialog from "./RideManageDialog";
// import { formatDate } from "../../utils/DateFormatter";
// import RefundDialog from "../../components/RefundDialog";

// const RideRecords = () => {
//   const [rides, setRides] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedRide, setSelectedRide] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);

//   const [refundDialogOpen, setRefundDialogOpen] = useState(false);
//   const [refundData, setRefundData] = useState({ paymentId: "", amount: 0 });

//   // Delete state
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [rideToDelete, setRideToDelete] = useState(null);
//   const [deleting, setDeleting] = useState(false);
//   const [snackbar, setSnackbar] = useState({ 
//     open: false, 
//     message: '', 
//     severity: 'success' 
//   });

//   const fetchRides = () => {
//     setLoading(true);
//     getAllRides()
//       .then((res) => {
//         setRides(res.data.data || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch rides:", err);
//         setLoading(false);
//         setSnackbar({
//           open: true,
//           message: 'Failed to fetch rides',
//           severity: 'error',
//         });
//       });
//   };

//   useEffect(() => {
//     fetchRides();
//   }, []);

//   const openManageDialog = (ride) => {
//     setSelectedRide(ride);
//     setOpenDialog(true);
//   };

//   const openRefundDialog = (ride) => {
//     setRefundData({
//       paymentId: ride.paymentDetails?.paymentId,
//       amount: null
//     });
//     setRefundDialogOpen(true);
//   };

//   const handleRefundConfirm = async () => {
//     try {
//       await refundRide(refundData.paymentId, refundData.amount);
//       setSnackbar({
//         open: true,
//         message: 'Refund processed successfully',
//         severity: 'success',
//       });
//       setRefundDialogOpen(false);
//       fetchRides();
//     } catch (err) {
//       console.error("Refund failed:", err);
//       setSnackbar({
//         open: true,
//         message: 'Refund failed. Please try again.',
//         severity: 'error',
//       });
//     }
//   };

//   // Delete handlers
//   const handleDeleteClick = (ride) => {
//     setRideToDelete(ride);
//     setDeleteDialogOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!rideToDelete) return;

//     try {
//       setDeleting(true);
      
//       // Call delete API - use production URL
//       const response = await fetch(`https://api.gatiii.com/api/bookings/${rideToDelete.bookingId}`, {
//         method: 'DELETE',
//       });
      
//       const data = await response.json();
      
//       if (data.status === 200) {
//         // Remove from local state
//         setRides(rides.filter(ride => ride.bookingId !== rideToDelete.bookingId));
        
//         setSnackbar({
//           open: true,
//           message: data.message || 'Ride deleted successfully',
//           severity: 'success',
//         });
//       } else {
//         throw new Error(data.message || 'Failed to delete');
//       }
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error.message || 'Failed to delete ride',
//         severity: 'error',
//       });
//     } finally {
//       setDeleting(false);
//       setDeleteDialogOpen(false);
//       setRideToDelete(null);
//     }
//   };

//   const handleDeleteCancel = () => {
//     setDeleteDialogOpen(false);
//     setRideToDelete(null);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const isRefundEligible = (ride) =>
//     ride.paymentDetails?.status === "SUCCESS" && !!ride.paymentDetails.paymentId;

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" mt={4}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box mt={4}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" gutterBottom>
//           Ride Booking Reports ({rides.length} rides)
//         </Typography>
//         <Button
//           variant="outlined"
//           onClick={fetchRides}
//           size="small"
//         >
//           🔄 Refresh
//         </Button>
//       </Box>

//       <TableContainer component={Paper}>
//         <Table size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell><strong>ID</strong></TableCell>
//               <TableCell><strong>Name</strong></TableCell>
//               <TableCell><strong>Contact</strong></TableCell>
//               <TableCell><strong>Email</strong></TableCell>
//               <TableCell><strong>Date</strong></TableCell>
//               <TableCell><strong>Home Address</strong></TableCell>
//               <TableCell><strong>Office Address</strong></TableCell>
//               <TableCell><strong>Passenger</strong></TableCell>
//               <TableCell><strong>Fare (₹)</strong></TableCell>
//               <TableCell><strong>Confirmed</strong></TableCell>
//               <TableCell><strong>Manage</strong></TableCell>
//               <TableCell><strong>Refund</strong></TableCell>
//               <TableCell align="center"><strong>Delete</strong></TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {rides.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={13} align="center">
//                   <Typography color="textSecondary" py={3}>
//                     No rides found
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               rides.map((ride) => {
//                 const canRefund = isRefundEligible(ride);
//                 return (
//                   <TableRow key={ride.bookingId} hover>
//                     <TableCell>{ride.bookingId}</TableCell>
//                     <TableCell>{ride.name}</TableCell>
//                     <TableCell>{ride.contactNumber}</TableCell>
//                     <TableCell>{ride.email}</TableCell>
//                     <TableCell>{formatDate(ride.toDate)}</TableCell>
//                     <TableCell>{ride.homeAddress}</TableCell>
//                     <TableCell>{ride.officeAddress}</TableCell>
//                     <TableCell>{ride.passengerCount}</TableCell>
//                     <TableCell>{ride.fare}</TableCell>
//                     <TableCell>{ride.isRideConfirmed ? "Yes" : "No"}</TableCell>
//                     <TableCell>
//                       <Button variant="outlined" onClick={() => openManageDialog(ride)}>
//                         Manage
//                       </Button>
//                     </TableCell>
//                     <TableCell>
//                       <Tooltip
//                         title={canRefund ? "Refund this payment" : "Refund not available"}
//                       >
//                         <span>
//                           <Button
//                             variant="contained"
//                             color="error"
//                             disabled={!canRefund}
//                             onClick={() => openRefundDialog(ride)}
//                             size="small"
//                           >
//                             Refund
//                           </Button>
//                         </span>
//                       </Tooltip>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Tooltip title="Delete this ride">
//                         <IconButton
//                           color="error"
//                           onClick={() => handleDeleteClick(ride)}
//                           size="small"
//                         >
//                           🗑️
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                   </TableRow>
//                 );
//               })
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {selectedRide && (
//         <RideManageDialog
//           open={openDialog}
//           onClose={() => setOpenDialog(false)}
//           ride={selectedRide}
//           onUpdated={fetchRides}
//         />
//       )}

//       <RefundDialog
//         open={refundDialogOpen}
//         onClose={() => setRefundDialogOpen(false)}
//         paymentId={refundData.paymentId}
//         amount={refundData.amount}
//         onConfirm={handleRefundConfirm}
//       />

//       {/* Delete Confirmation Dialog */}
//       <Dialog 
//         open={deleteDialogOpen} 
//         onClose={handleDeleteCancel}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>Delete Ride Booking</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete this ride booking?
//           </Typography>
//           {rideToDelete && (
//             <Box mt={2} p={2} bgcolor="grey.100" borderRadius={1}>
//               <Typography variant="body2"><strong>Booking ID:</strong> {rideToDelete.bookingId}</Typography>
//               <Typography variant="body2"><strong>Name:</strong> {rideToDelete.name}</Typography>
//               <Typography variant="body2"><strong>Email:</strong> {rideToDelete.email}</Typography>
//               <Typography variant="body2"><strong>Fare:</strong> ₹{rideToDelete.fare}</Typography>
//               <Typography variant="body2"><strong>Date:</strong> {formatDate(rideToDelete.toDate)}</Typography>
//             </Box>
//           )}
//           <Typography color="error" variant="body2" mt={2}>
//             ⚠️ This action cannot be undone.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCancel} disabled={deleting}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDeleteConfirm}
//             color="error"
//             variant="contained"
//             disabled={deleting}
//           >
//             {deleting ? 'Deleting...' : '🗑️ Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           onClose={handleSnackbarClose} 
//           severity={snackbar.severity} 
//           sx={{ width: '100%' }}
//           variant="filled"
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default RideRecords;
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Box,
  Paper,
  TableContainer,
  Button,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Chip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Avatar,
  Divider,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import GroupIcon from "@mui/icons-material/Group";
import RefreshIcon from "@mui/icons-material/Refresh";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  getAllRides,
  refundRide,
  getAssignmentForBooking,
  cancelAssignment,
} from "../../services/api";
import RideManageDialog from "./RideManageDialog";
import { formatDate } from "../../utils/DateFormatter";
import RefundDialog from "../../components/RefundDialog";
import AssignVendorDialog from "../../components/AssignVendorDialog";

const RideRecords = () => {
  const [rides, setRides] = useState([]);
  const [assignments, setAssignments] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedRide, setSelectedRide] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [refundData, setRefundData] = useState({ paymentId: "", amount: 0 });

  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [bookingToAssign, setBookingToAssign] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rideToDelete, setRideToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuRide, setMenuRide] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchRides = async () => {
    setLoading(true);
    try {
      const res = await getAllRides();
      const fetchedRides = res.data.data || [];
      setRides(fetchedRides);

      const assignmentPromises = fetchedRides.map((ride) =>
        getAssignmentForBooking(ride.bookingId)
          .then((r) => ({ bookingId: ride.bookingId, assignment: r.data.data }))
          .catch(() => ({ bookingId: ride.bookingId, assignment: null }))
      );

      const results = await Promise.all(assignmentPromises);
      const map = {};
      results.forEach(({ bookingId, assignment }) => {
        if (assignment) map[bookingId] = assignment;
      });
      setAssignments(map);
    } catch (err) {
      console.error("Failed to fetch rides:", err);
      setSnackbar({
        open: true,
        message: "Failed to fetch rides",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRides();
  }, []);

  const handleMenuOpen = (event, ride) => {
    setMenuAnchor(event.currentTarget);
    setMenuRide(ride);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setMenuRide(null);
  };

  const openManageDialog = (ride) => {
    setSelectedRide(ride);
    setOpenDialog(true);
    handleMenuClose();
  };

  const openRefundDialog = (ride) => {
    setRefundData({
      paymentId: ride.paymentDetails?.paymentId,
      amount: null,
    });
    setRefundDialogOpen(true);
    handleMenuClose();
  };

  const openAssignDialog = (ride) => {
    setBookingToAssign(ride);
    setAssignDialogOpen(true);
    handleMenuClose();
  };

  const handleAssignmentDone = (message) => {
    setSnackbar({ open: true, message, severity: "success" });
    setAssignDialogOpen(false);
    setBookingToAssign(null);
    fetchRides();
  };

  const handleUnassign = async (assignmentId) => {
    handleMenuClose();
    if (!window.confirm("Cancel this assignment? Booking will revert to pending.")) {
      return;
    }
    try {
      await cancelAssignment(assignmentId);
      setSnackbar({
        open: true,
        message: "Assignment cancelled",
        severity: "success",
      });
      fetchRides();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.message || "Failed to cancel",
        severity: "error",
      });
    }
  };

  const handleRefundConfirm = async () => {
    try {
      await refundRide(refundData.paymentId, refundData.amount);
      setSnackbar({
        open: true,
        message: "Refund processed successfully",
        severity: "success",
      });
      setRefundDialogOpen(false);
      fetchRides();
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Refund failed. Please try again.",
        severity: "error",
      });
    }
  };

  const handleDeleteClick = (ride) => {
    setRideToDelete(ride);
    setDeleteDialogOpen(true);
    handleMenuClose();
  };

  const handleDeleteConfirm = async () => {
    if (!rideToDelete) return;

    try {
      setDeleting(true);
      const response = await fetch(
        `https://api.gatiii.com/api/bookings/${rideToDelete.bookingId}`,
        { method: "DELETE" }
      );
      const data = await response.json();

      if (data.status === 200) {
        setRides(rides.filter((r) => r.bookingId !== rideToDelete.bookingId));
        setSnackbar({
          open: true,
          message: data.message || "Ride deleted successfully",
          severity: "success",
        });
      } else {
        throw new Error(data.message || "Failed to delete");
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to delete ride",
        severity: "error",
      });
    } finally {
      setDeleting(false);
      setDeleteDialogOpen(false);
      setRideToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setRideToDelete(null);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const isRefundEligible = (ride) =>
    ride.paymentDetails?.status === "SUCCESS" && !!ride.paymentDetails.paymentId;

  // Format time only — "09:30 AM"
  const formatTime = (dateString) => {
    if (!dateString) return "—";
    try {
      const date = new Date(dateString);
      return date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      return "—";
    }
  };

  const getStatusChip = (ride) => {
    const configs = {
      0: { label: "Awaiting Confirmation", color: "warning" },
      1: { label: "Confirmed", color: "success" },
      2: { label: "Cancelled", color: "error" },
      3: { label: "Completed", color: "default" },
    };
    const cfg = configs[ride.isRideConfirmed] || { label: "Unknown", color: "default" };
    return <Chip label={cfg.label} color={cfg.color} size="small" sx={{ fontWeight: 600 }} />;
  };

  const getAvatarColor = (name) => {
    const colors = [
      "#1976d2", "#388e3c", "#d32f2f", "#7b1fa2",
      "#c2185b", "#0288d1", "#f57c00", "#5d4037",
    ];
    if (!name) return colors[0];
    const charCode = name.charCodeAt(0);
    return colors[charCode % colors.length];
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  const currentAssignment = menuRide ? assignments[menuRide.bookingId] : null;
  const canAssign = menuRide && (!currentAssignment || currentAssignment.status === "CANCELLED");
  const canUnassign = menuRide && currentAssignment && currentAssignment.status !== "CANCELLED";
  const canRefund = menuRide && isRefundEligible(menuRide);

  // Summary stats
  const totalConfirmed = rides.filter((r) => r.isRideConfirmed === 1).length;
  const totalPending = rides.filter((r) => r.isRideConfirmed === 0).length;
  const totalAssigned = Object.values(assignments).filter((a) => a && a.status !== "CANCELLED").length;

  // Common header cell style
  const headerCellSx = {
    fontWeight: 600,
    fontSize: "0.875rem",
    color: "text.primary",
    py: 1.5,
    bgcolor: "#f8f9fa",
  };

  return (
    <Box mt={2}>
      {/* Stats Cards */}
      <Stack direction="row" spacing={2} mb={3} flexWrap="wrap">
        <Paper elevation={0} sx={{ p: 2, flex: 1, minWidth: 150, border: "1px solid", borderColor: "divider" }}>
          <Typography variant="caption" color="text.secondary">Total Bookings</Typography>
          <Typography variant="h5" fontWeight="bold">{rides.length}</Typography>
        </Paper>
        <Paper elevation={0} sx={{ p: 2, flex: 1, minWidth: 150, border: "1px solid", borderColor: "warning.light", bgcolor: "warning.50" }}>
          <Typography variant="caption" color="warning.dark">Pending</Typography>
          <Typography variant="h5" fontWeight="bold" color="warning.dark">{totalPending}</Typography>
        </Paper>
        <Paper elevation={0} sx={{ p: 2, flex: 1, minWidth: 150, border: "1px solid", borderColor: "success.light", bgcolor: "success.50" }}>
          <Typography variant="caption" color="success.dark">Confirmed</Typography>
          <Typography variant="h5" fontWeight="bold" color="success.dark">{totalConfirmed}</Typography>
        </Paper>
        <Paper elevation={0} sx={{ p: 2, flex: 1, minWidth: 150, border: "1px solid", borderColor: "primary.light", bgcolor: "primary.50" }}>
          <Typography variant="caption" color="primary.dark">Drivers Assigned</Typography>
          <Typography variant="h5" fontWeight="bold" color="primary.dark">{totalAssigned}</Typography>
        </Paper>
      </Stack>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="bold">All Bookings</Typography>
        <Button variant="outlined" onClick={fetchRides} size="small" startIcon={<RefreshIcon />}>
          Refresh
        </Button>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headerCellSx}>Booking ID</TableCell>
              <TableCell sx={headerCellSx}>Customer</TableCell>
              <TableCell sx={{ ...headerCellSx, minWidth: 200 }}>Schedule</TableCell>
              <TableCell sx={{ ...headerCellSx, minWidth: 280 }}>Pickup & Drop</TableCell>
              <TableCell sx={headerCellSx}>Trip Details</TableCell>
              <TableCell sx={headerCellSx}>Booking Status</TableCell>
              <TableCell sx={{ ...headerCellSx, minWidth: 220 }}>Assigned Driver</TableCell>
              <TableCell align="center" sx={headerCellSx}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rides.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 6 }}>
                  <Typography color="textSecondary">No bookings found yet</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rides.map((ride) => {
                const assignment = assignments[ride.bookingId];
                const showAssignment = assignment && assignment.status !== "CANCELLED";

                return (
                  <TableRow
                    key={ride.bookingId}
                    hover
                    sx={{
                      "&:last-child td": { borderBottom: 0 },
                      "& td": { py: 2 },
                    }}
                  >
                    {/* Booking ID */}
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold" color="primary">
                        #{ride.bookingId}
                      </Typography>
                    </TableCell>

                    {/* Customer */}
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <Avatar
                          sx={{
                            bgcolor: getAvatarColor(ride.name),
                            width: 36,
                            height: 36,
                            fontSize: "0.85rem",
                            fontWeight: 700,
                          }}
                        >
                          {ride.name?.charAt(0)?.toUpperCase() || "?"}
                        </Avatar>
                        <Box>
                          <Typography variant="body2" fontWeight={600}>
                            {ride.name}
                          </Typography>
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <PhoneIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                            <Typography variant="caption" color="text.secondary">
                              {ride.contactNumber}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </TableCell>

                    {/* Schedule — Date + Login + Logout times */}
                    <TableCell>
                      <Stack spacing={0.75}>
                        {/* Date */}
                        <Box display="flex" alignItems="center" gap={0.75}>
                          <EventIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                          <Typography variant="body2" fontWeight={500}>
                            {formatDate(ride.fromDate)}
                          </Typography>
                        </Box>

                        <Divider sx={{ my: 0.25 }} />

                        {/* Login (Office Arrival) */}
                        <Box display="flex" alignItems="center" gap={0.75}>
                          <LoginIcon sx={{ fontSize: 14, color: "success.main" }} />
                          <Box>
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1 }}>
                              Login (Office)
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatTime(ride.officeArrivalTime)}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Logout (Office Departure) */}
                        <Box display="flex" alignItems="center" gap={0.75}>
                          <LogoutIcon sx={{ fontSize: 14, color: "error.main" }} />
                          <Box>
                            <Typography variant="caption" color="text.secondary" sx={{ display: "block", lineHeight: 1 }}>
                              Logout (Office)
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {formatTime(ride.officeDepartureTime)}
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </TableCell>

                    {/* Pickup & Drop */}
                    <TableCell>
                      <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
                        <LocationOnIcon sx={{ color: "success.main", fontSize: 18, mt: 0.2 }} />
                        <Box>
                          <Typography
                            variant="caption"
                            color="success.dark"
                            fontWeight={700}
                            display="block"
                          >
                            PICKUP
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                            {ride.homeAddress}
                          </Typography>
                        </Box>
                      </Box>
                      <Box display="flex" alignItems="flex-start" gap={1}>
                        <BusinessIcon sx={{ color: "error.main", fontSize: 18, mt: 0.2 }} />
                        <Box>
                          <Typography
                            variant="caption"
                            color="error.dark"
                            fontWeight={700}
                            display="block"
                          >
                            DROP
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                            {ride.officeAddress}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    {/* Trip Details */}
                    <TableCell>
                      <Stack spacing={0.5}>
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <GroupIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                          <Typography variant="body2">
                            {ride.passengerCount} {ride.passengerCount === 1 ? "passenger" : "passengers"}
                          </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <LocalTaxiIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                          <Typography variant="body2">{ride.distance} km</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <CurrencyRupeeIcon sx={{ fontSize: 14, color: "success.main" }} />
                          <Typography variant="body2" fontWeight={600} color="success.dark">
                            {ride.fare}
                          </Typography>
                        </Box>
                      </Stack>
                    </TableCell>

                    {/* Status */}
                    <TableCell>{getStatusChip(ride)}</TableCell>

                    {/* Assigned Driver */}
                    <TableCell>
                      {showAssignment ? (
                        <Box>
                          <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                            <PersonIcon sx={{ fontSize: 16, color: "primary.main" }} />
                            <Typography variant="body2" fontWeight={600}>
                              {assignment.vendor.vendorName}
                            </Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                            <PhoneIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                            <Typography variant="caption" color="text.secondary">
                              {assignment.vendor.contactNumber}
                            </Typography>
                          </Box>
                          {assignment.pickupTime && (
                            <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
                              <AccessTimeIcon sx={{ fontSize: 12, color: "text.secondary" }} />
                              <Typography variant="caption" color="text.secondary">
                                Pickup: {assignment.pickupTime}
                              </Typography>
                            </Box>
                          )}
                          <Chip
                            label={assignment.status}
                            size="small"
                            color={
                              assignment.status === "COMPLETED" ? "success" :
                              assignment.status === "CANCELLED" ? "error" : "primary"
                            }
                            sx={{ fontSize: "0.65rem", height: 20, mt: 0.5 }}
                          />
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            p: 1,
                            border: "1px dashed",
                            borderColor: "warning.light",
                            borderRadius: 1,
                            bgcolor: "warning.50",
                          }}
                        >
                          <Typography variant="caption" color="warning.dark" fontWeight={600}>
                            ⚠ No driver assigned
                          </Typography>
                        </Box>
                      )}
                    </TableCell>

                    {/* Actions */}
                    <TableCell align="center">
                      <Tooltip title="More actions">
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, ride)}
                          sx={{
                            border: "1px solid",
                            borderColor: "divider",
                            "&:hover": { bgcolor: "primary.50" },
                          }}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Action menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        PaperProps={{ elevation: 3, sx: { minWidth: 220, mt: 1 } }}
      >
        {canAssign && (
          <MenuItem onClick={() => openAssignDialog(menuRide)}>
            <ListItemIcon><LocalTaxiIcon fontSize="small" color="primary" /></ListItemIcon>
            <ListItemText
              primary="Assign Driver"
              secondary="Assign a vendor to this ride"
              secondaryTypographyProps={{ fontSize: "0.7rem" }}
            />
          </MenuItem>
        )}

        {canUnassign && (
          <MenuItem onClick={() => handleUnassign(currentAssignment.assignmentId)}>
            <ListItemIcon><CancelIcon fontSize="small" color="warning" /></ListItemIcon>
            <ListItemText
              primary="Unassign Driver"
              secondary="Cancel current assignment"
              secondaryTypographyProps={{ fontSize: "0.7rem" }}
            />
          </MenuItem>
        )}

        <MenuItem onClick={() => openManageDialog(menuRide)}>
          <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
          <ListItemText
            primary="Edit Booking"
            secondary="Change times or status"
            secondaryTypographyProps={{ fontSize: "0.7rem" }}
          />
        </MenuItem>

        {canRefund && (
          <MenuItem onClick={() => openRefundDialog(menuRide)}>
            <ListItemIcon><CurrencyRupeeIcon fontSize="small" color="error" /></ListItemIcon>
            <ListItemText
              primary="Process Refund"
              secondary="Refund the payment"
              secondaryTypographyProps={{ fontSize: "0.7rem" }}
            />
          </MenuItem>
        )}

        <MenuItem onClick={() => handleDeleteClick(menuRide)} sx={{ color: "error.main" }}>
          <ListItemIcon><DeleteIcon fontSize="small" color="error" /></ListItemIcon>
          <ListItemText
            primary="Delete Booking"
            secondary="Permanently remove"
            secondaryTypographyProps={{ fontSize: "0.7rem" }}
          />
        </MenuItem>
      </Menu>

      {/* Dialogs */}
      {selectedRide && (
        <RideManageDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          ride={selectedRide}
          onUpdated={fetchRides}
        />
      )}

      <AssignVendorDialog
        open={assignDialogOpen}
        onClose={() => {
          setAssignDialogOpen(false);
          setBookingToAssign(null);
        }}
        booking={bookingToAssign}
        onAssigned={handleAssignmentDone}
      />

      <RefundDialog
        open={refundDialogOpen}
        onClose={() => setRefundDialogOpen(false)}
        paymentId={refundData.paymentId}
        amount={refundData.amount}
        onConfirm={handleRefundConfirm}
      />

      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Delete Ride Booking</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this ride booking?</Typography>
          {rideToDelete && (
            <Box mt={2} p={2} bgcolor="grey.100" borderRadius={1}>
              <Typography variant="body2"><strong>Booking ID:</strong> #{rideToDelete.bookingId}</Typography>
              <Typography variant="body2"><strong>Customer:</strong> {rideToDelete.name}</Typography>
              <Typography variant="body2"><strong>Email:</strong> {rideToDelete.email}</Typography>
              <Typography variant="body2"><strong>Fare:</strong> ₹{rideToDelete.fare}</Typography>
              <Typography variant="body2"><strong>Date:</strong> {formatDate(rideToDelete.toDate)}</Typography>
            </Box>
          )}
          <Typography color="error" variant="body2" mt={2}>⚠️ This action cannot be undone.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleting}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={deleting}>
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RideRecords;